import React from 'react';

import Contracts from '../components/Contracts/Contracts';

function ContractsPage() {
  return <Contracts />;
}

export default ContractsPage;
